<div class="list-options">
    <div
        *ngFor="let listOption of listOptions"
        class="list-option"
    >
        <label
            [for]="listOption.id"
            class="list-option-elements"
            [ngClass]="{'option-selected': optionSelected?.id === listOption?.id}"
        >
            <div class="list-option-title">
                <img class="title-icon" [src]="listOption.iconSource" alt="{{listOption.id}}-icon"/>
                <div class="title-text">{{ listOption.optionText | translate }}</div>
            </div>
            <div class="list-option-input">
                <input
                    type="radio"
                    [id]="listOption.id"
                    name="list-option"
                    [value]="listOption.value"
                    (change)="onOptionChange(listOption)"
                />
                <label [for]="listOption.id"></label>
            </div>
        </label>
        <div *ngIf="listOption.selectedShowText && optionSelected?.id === listOption?.id" class="list-option-text-selected">
            <img class="selected-text-icon" src="assets/images/icons/safety-alert-icon.png" alt="safety-alert-icon"/>
            <div class="selected-text">{{ listOption.selectedShowText | translate }}</div>
        </div>
    </div>
</div>